import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import OptimizerTableDto from '../dto/OptimizerTableDto';

class OptimizerTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'optimizerTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<OptimizerTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, OptimizerTableDto)))
				.catch(reject);
		});
	}
}

export default new OptimizerTableService();
